



























import { Mixins, Component } from 'vue-property-decorator'
import BlockchainDataTable from '@/components/Blockchain/BlockchainDataTable.vue'
import { AuthorityGettersMixin } from '@/store/modules/authority/authority.mixins'
import Blockchain from '@/js/Blockchain'
import Loader from '@/components/misc/Loader.vue'
import { DEFAULT_NETWORK_NAME } from '@/store/modules/network/network'

@Component({
    components: {
        BlockchainDataTable,
        Loader,
    },
})
export default class Blockchains extends Mixins(AuthorityGettersMixin) {
    loading = true

    mounted() {
        this.loading = false
    }

    get subnetsLoaded() {
        return this.$store.state.Authority.subnetsLoaded
    }

    get blockchains() {
        const blockchain: Blockchain[] = []
        // if (DEFAULT_NETWORK_NAME === 'goldcoast') {
        //     this.$store.state.Authority.blockchains.map(
        //         (x: any, key: number) => {
        //             if (key !== 1 && key !== 2) {
        //                 blockchain.push(x)
        //             }
        //         }
        //     )
        //     return (blockchain as Blockchain[]).sort((a, b) =>
        //         a.subnetID > b.subnetID ? 1 : b.subnetID > a.subnetID ? -1 : 0
        //     )
        // } else {
        return (this.$store.state.Authority
            .blockchains as Blockchain[]).sort((a, b) =>
            a.subnetID > b.subnetID ? 1 : b.subnetID > a.subnetID ? -1 : 0
        )
        // }
    }

    get totalBlockchains() {
        if (DEFAULT_NETWORK_NAME === 'goldcoast') {
            const data = this.getTotalBlockchains()
            if (data > 0) {
                return data - 2
            } else {
                return data
            }
        } else {
            return this.getTotalBlockchains()
        }
    }
}
